var   $          = global.jQuery
     ,ko         = require('knockout')
     ,core       = require('CoreModule')
     ,events     = core.Events
     ,helpers    = core.Helpers;

var BusyViewModel = function(model){

    var self = this;
    self.Modes    = { getting_call: 'getting_call', storing_call: 'storing_call' }
    self.Mode     = ko.observable(model.Mode    );  
    self.Complete = ko.observable(model.Complete);
    self.ErrorMsg = ko.observable(model.ErrorMsg);

    self.GettingCall = ko.pureComputed(function(){ self.Mode() === self.Modes.getting_call });
    self.StoringCall = ko.pureComputed(function(){ self.Mode() === self.Modes.storing_call });

        
    
    self.helpers = helpers;
    
    var maxMessages = 10;

    self.MaxMessages = maxMessages;
    
    self.Messages = model.BusyMessages;

    self.LimitedMessages = ko.pureComputed(function(){ return model.BusyMessages().length <= maxMessages ? model.BusyMessages : _.take(model.BusyMessages, maxMessages) })
    
    self.getOpacity = function(val){ return (maxMessages - _.clamp(val, 0, maxMessages)) / maxMessages }
    
    var init = (function(){
        
        console.log('BusyViewModel');
        
        
    })();
    

}

module.exports = BusyViewModel;

module.exports = {
     viewModel: BusyViewModel
    ,template : require('BusyView.html')
    ,title    : 'Busy..'

};